function appendingParameterToURL(key, value) {
  const url = new URL(window.location.href);
  url.searchParams.delete(key);
  url.searchParams.set(key, value);
  window.history.replaceState(null, null, url);
}

export {
  appendingParameterToURL
}